/* @flow */
// typecheck: ignore file
import React, { Component } from 'react';
import { mountModal } from 'lib/modal';
import ActivityCreateDialogContainer from 'payments/containers/ActivityCreateDialogContainer.jsx';
import Button from 'components/Button.jsx';
import Link from 'components/Link.jsx';
import Glyph from 'components/Glyph.jsx';
import Image from 'components/Image.jsx';

import './styles/ActivityComposerTooltip.scss';

class ActivityComposerTooltip extends Component {
  props: {
    dismiss: Function,
    onActivitySent?: ?Function,
  };

  onClose = (event: SyntheticEvent): void => {
    event.stopPropagation();
    this.props.dismiss();
  };

  mountActivityModal = (event: SyntheticEvent): void => {
    event.stopPropagation();
    mountModal(<ActivityCreateDialogContainer onActivitySent={this.props.onActivitySent} />, this);
  }

  render() {
    return (
      <div
        className="ActivityComposerTooltip"
        onClick={this.mountActivityModal}>
        <div className="ActivityComposerTooltip-content">
          <Image
            className="ActivityComposerTooltip-content-img"
            src={require('assets/images/payments/activity-celebration.svg')}
          />
          <div className="ActivityComposerTooltip-content-text">
            <Link
              className="ActivityComposerTooltip-content-text-header"
              onClick={this.mountActivityModal}
              eventElementName="ActivityComposerTooltip-content-text-header">
              Click to organize your event or activity on Remind
            </Link>
            <span className="ActivityComposerTooltip-content-text-subtext">
              Use Remind to send invitations, track participants, and collect funds!
            </span>
          </div>
        </div>
        <Button
          color="koala"
          level="text"
          className="ActivityComposerTooltip-closeButton"
          onClick={this.onClose}
          eventElementName="ActivityComposerTooltip-closeButton">
          <Glyph name="close" size="small" solo />
        </Button>
      </div>
    );
  }
}

export default ActivityComposerTooltip;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityComposerTooltip.jsx